import { Component, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from './views/CommonView';
import BASEAPI from './util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from './util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class App extends Mixins(CommonView) {

    public error: string = "";

    public async created() {
        await this.init();
    }

    @Watch('$route')
    public async init() {
        await this.getUserAPI();
    }

    public async logout() {
        let res = await BASEAPI.LoginController.logoutUsingDELETE().catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            return;
        }
        await this.getUserAPI();
        this.$router.push("/", () => {});
    }

}
